export default "__VITE_ASSET__EWtVcSEZ__"